import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Products, { BrownHatHeader } from "./assets/Products";
import { images } from "./assets/Products";
import { theme } from "./assets/theme";
import { FaArrowLeft, FaRotate } from "react-icons/fa6";
import YMLogo from "./assets/YMLogo";

const ProductPage = ({ products }) => {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  window.addEventListener("popstate", () => {
    window.location.replace("/store");
  });
  const productImage = document.getElementById("product-image");
  const productDetails = document.getElementById("product-details");
  const imageWidth = productDetails?.offsetLeft - productImage?.offsetLeft;
  const imageLength = images.length;
  const imageInterval =
    imageWidth === 0
      ? window.innerWidth / imageLength
      : imageWidth / imageLength;
  const [currentImage, setCurrentImage] = useState(BrownHatHeader);
  const [overlay, setOverlay] = useState(true);

  return (
    <div
      className={`bg-[${theme.main}] h-full min-h-screen w-screen`}
      onDragStart={(e) => {
        e.preventDefault();
      }}
    >
      <nav className={`flex w-full items-center justify-between px-5 py-0`}>
        <div
          onClick={() => {
            navigate("/store");
          }}
          className={`rounded-full p-2.5 hover:bg-white`}
        >
          <FaArrowLeft />
        </div>
        <div className="min-w-1/4 flex w-1/4 max-w-[150px] shrink items-center justify-center ">
          <YMLogo fill={"black"} />
        </div>
        <div
          className={`invisible w-[40px] rounded-full p-2.5 hover:bg-white`}
        ></div>
      </nav>
      {/* Rendering Specific Product */}
      {Products.map((item) => {
        if (item.id == id) {
          return (
            <div key={item.id} className="grid grid-cols-1 lg:grid-cols-2">
              <div className={`relative flex w-full`}>
                {overlay && (
                  <div
                    className="absolute flex h-full w-full items-center bg-white/60"
                    onClick={() => {
                      setOverlay(false);
                    }}
                  >
                    <div className="flex w-full items-center justify-center gap-[2.5vw] text-center">
                      <FaRotate /> <p>Drag Me to rotate 360&deg;</p>
                      <FaRotate />
                    </div>
                  </div>
                )}
                <img
                  id="product-image"
                  alt="product"
                  className="product-page-image"
                  src={currentImage}
                  onMouseLeave={(e) => {
                    setCurrentImage(BrownHatHeader);
                    // console.log(
                    //   productDetails.offsetLeft - e.currentTarget.offsetLeft,
                    // );
                  }}
                  onTouchMove={(e) => {
                    console.log(
                      e.changedTouches[e.changedTouches.length - 1].clientX /
                        imageInterval,
                    );
                    const index = Math.floor(
                      e.changedTouches[e.changedTouches.length - 1]?.clientX /
                        imageInterval,
                    );
                    if (index >= 0 && index < images.length) {
                      setCurrentImage(images[index]);
                    }
                  }}
                  onMouseMove={(e) => {
                    const index = Math.floor(e.clientX / imageInterval);
                    setCurrentImage(images[index]);
                    if (index >= 0 && index < images.length) {
                      setCurrentImage(images[index]);
                    }
                    // console.log(e.clientX, e.clientY);
                  }}
                />
              </div>

              <div
                id="product-details"
                className={`flex flex-col gap-2 p-2 text-[24px] `}
              >
                <div>{item.title}</div>
                <div>${item.price}</div>
                <div>{item.description}</div>
                {/* 
                <div className="product-page-size-title">Size:</div>
                <div className="grid grid-cols-5 items-center justify-items-center gap-[5vw] px-4">
                  {["sm", "md", "lg", "xlg", "xxlg"].map((itemSize, i) => {
                    if (searchParams.get("size") === itemSize) {
                      return (
                        <div
                          key={`size-${i}`}
                          className={`flex h-[10vw] max-h-[100px] w-[10vw] max-w-[100px] items-center justify-center rounded-full border-2 border-black bg-[#53e639] p-7`}
                        >
                          <p>{itemSize}</p>
                        </div>
                      );
                    }
                    return (
                      <div
                        key={`size-${i}`}
                        className={`flex h-[10vw] max-h-[100px] w-[10vw] max-w-[100px] cursor-pointer items-center justify-center rounded-full border-2 border-black bg-white p-7 text-black transition-colors duration-300 ease-in-out hover:border-white hover:bg-[#53e639]`}
                        onClick={() => {
                          setSearchParams({
                            size: itemSize,
                          });
                        }}
                      >
                        {itemSize}
                      </div>
                    );
                  })}
                </div> */}
                {/* <input type="number" /> */}
                <div className="mt-[20px] flex min-h-[40px]  cursor-pointer items-center justify-center rounded-md border-2 border-black transition-colors duration-300 ease-in-out hover:border-white hover:bg-black hover:text-white">
                  Add to Cart
                </div>
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default ProductPage;
